import { ButtonWithScaleAnimation } from "by/gamefactory/cityversetycoon/scenes/common/components/ButtonWithScaleAnimation";
import { MyWalletTab } from "../tabs/MyWalletTab";

export class MyWalletScrollController {
    private readonly leftArrow: ButtonWithScaleAnimation;
    private readonly rightArrow: ButtonWithScaleAnimation;

    private currentTabValue: MyWalletTab;

    public set currentTab(tab: MyWalletTab) {
        this.currentTabValue?.onScrollItemsCountChange?.remove(this.processArrowsVisible, this);
        this.currentTabValue = tab;
        this.currentTabValue.onScrollItemsCountChange?.add(this.processArrowsVisible, this);
        this.processArrowsVisible();
    }

    private set arrowsBlocked(blocked: boolean) {
        this.leftArrow.enabled = !blocked;
        this.rightArrow.enabled = !blocked;
    }

    public constructor(
        leftArrow: ButtonWithScaleAnimation,
        rightArrow: ButtonWithScaleAnimation,
        currentTab: MyWalletTab
    ) {
        this.leftArrow = leftArrow;
        this.rightArrow = rightArrow;
        this.currentTabValue = currentTab;
        this.currentTabValue.onScrollItemsCountChange?.add(this.processArrowsVisible, this);
        this.leftArrow.onUp.add(this.onLeftArrowClick, this);
        this.rightArrow.onUp.add(this.onRightArrowClick, this);
        this.processArrowsVisible();
    }

    public processArrowsVisible(): void {
        const itemsCount = this.currentTabValue.scrollElements ?? 0;
        const currentItenIndex = this.currentTabValue.currentScrollItemIndex ?? 0;
        this.leftArrow.visible = currentItenIndex == 0 ? false : true;
        this.rightArrow.visible = (itemsCount - 1) - currentItenIndex > 0 ? true : false;
    }

    public async onLeftArrowClick(): Promise<void> {
        this.arrowsBlocked = true;
        await this.currentTabValue.scrollLeft();
        this.processArrowsVisible();
        this.arrowsBlocked = false;
    }

    public async onRightArrowClick(): Promise<void> {
        this.arrowsBlocked = true;
        await this.currentTabValue.scrollRight();
        this.processArrowsVisible();
        this.arrowsBlocked = false;
    }

    public destroy(): void {
        this.currentTabValue?.onScrollItemsCountChange?.remove(this.processArrowsVisible, this);
        this.leftArrow.onUp.remove(this.onLeftArrowClick, this);
        this.rightArrow.onUp.remove(this.onRightArrowClick, this);
    }
}